import requests from "./httpService";
import secureLocalStorage from "react-secure-storage";

const LoginService = {
  loginAdmin(body) {
    return requests.post(`/user/login`, body);
  },
  initialPasswordReset(body) {
    return requests.post(`/user/initial-password-reset`, body);
  },
  logout() {
    // Preserve per-day birthday-shown flags so the popup doesn't reappear
    // when the user logs back in on the same day after a session expiry.
    const preserved = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("birthday_celebrated_")) {
        preserved[key] = localStorage.getItem(key);
      }
    }
    secureLocalStorage.clear();
    Object.entries(preserved).forEach(([k, v]) => localStorage.setItem(k, v));
  }
};

export default LoginService;
